/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import axios from 'axios';

// Set axios to send credentials with requests
axios.defaults.withCredentials = true;

// Set the base URL based on environment
if (process.env.NODE_ENV === 'production') {
  // In production, let calls use absolute paths (e.g., '/api/...')
  axios.defaults.baseURL = '';
} else {
  // In development, connect directly to backend
  axios.defaults.baseURL = 'http://localhost:5050';
}


// Create the root element for React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
